import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=12f37a46&scoped=true&"
import script from "./ReCaptcha.vue?vue&type=script&lang=ts&"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f37a46",
  null
  
)

export default component.exports